/**
 * @generated SignedSource<<0389bd5f5d93ed8340240b04586b9c78>>
 * @flow
 * @lightSyntaxTransform
 * @nogrep
 */

/* eslint-disable */

'use strict';

/*::
import type { Fragment, ReaderFragment } from 'relay-runtime';
import type { FragmentType } from "relay-runtime";
declare export opaque type RecoveryCodeList_recoveryCodes$fragmentType: FragmentType;
export type RecoveryCodeList_recoveryCodes$data = {|
  +codes: $ReadOnlyArray<{|
    +code: string,
    +consumed: boolean,
  |}>,
  +$fragmentType: RecoveryCodeList_recoveryCodes$fragmentType,
|};
export type RecoveryCodeList_recoveryCodes$key = {
  +$data?: RecoveryCodeList_recoveryCodes$data,
  +$fragmentSpreads: RecoveryCodeList_recoveryCodes$fragmentType,
  ...
};
*/

var node/*: ReaderFragment*/ = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "RecoveryCodeList_recoveryCodes",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "RecoveryCode",
      "kind": "LinkedField",
      "name": "codes",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "code",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "consumed",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "RecoveryCodeBatch",
  "abstractKey": null
};

(node/*: any*/).hash = "98a7688591ffb00960f4b4acc49ca216";

module.exports = ((node/*: any*/)/*: Fragment<
  RecoveryCodeList_recoveryCodes$fragmentType,
  RecoveryCodeList_recoveryCodes$data,
>*/);
